<script lang="ts">
  import { onMount } from "svelte"
  import Layout from "$app/Layouts/University.svelte"
  import PodcastEpisode from "./PodcastEpisode.svelte"
  import Sidebar from "./Sidebar.svelte"
  import episodes_svg from "$app/images/university/episodes.svg"
  import { ArrowLeft } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    plan: PlanType
    podcast_episode: PodcastEpisodeType
    current_user: UserType
  }

  let props = $props()
  let { plan, podcast_episode, current_user }: Props = props

  onMount(() => {
    appStore.current_user = current_user
    appStore.plan = plan
  })

  const podcast_img = new URL(
    `/images/university/podcast-sm.jpg`,
    import.meta.url
  ).href
</script>

<Layout {...props}>
  <div
    class="bg-gradient-to-r from-course-bg-light to-course-bg-dark w-full border-t-border-b-2 border-gray-800"
  >
    <div
      class="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-3 items-center sm:px-6 lg:px-8"
    >
      <div class="flex justify-start items-center">
        <a
          href="/plans/{appStore.plan.id}/university"
          class="flex items-center justify-start hover:border-b hover:font-bold text-white"
        >
          <ArrowLeft class="h-6 w-6 text-white mr-1" />
          Back to University
        </a>
      </div>
      <div class="py-3">
        <div class="flex items-center justify-center">
          <img
            class="inline-block h-6 w-6 rounded-full shadow bg-gray-50 p-1"
            src={appStore.plan.logo_url}
            alt="Logo"
          />
          <p
            class="text-base leading-tight text-gray-200 ml-2"
            data-name="plan-name"
          >
            {appStore.plan.name}
          </p>
        </div>
        <h1 class="text-white text-2xl text-center mt-1">
          Surfacing Leaders Podcast
        </h1>
      </div>
    </div>
  </div>

  <div class="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
    <div class="grid grid-cols-3">
      <div class="relative">
        <Sidebar />
      </div>
      <div class="col-span-2">
        <main
          class="border-t border-slate-200 lg:border-t-0 relative bg-indigo-50"
        >
          <img
            src={episodes_svg}
            class="absolute left-0 top-0 h-20 w-full"
            alt="Episodes"
          />

          <div class="relative">
            <div class="pt-24 lg:pt-32">
              <div class="lg:px-8 lg:max-w-4xl">
                <div class="mx-auto md:max-w-2xl">
                  <a
                    href="/plans/{appStore.plan.id}/podcast"
                    class="text-gray-600 hover:underline hover:text-blue-700 flex items-center"
                  >
                    <ArrowLeft class="h-6 w-6 text-gray-500" />
                    Back to All Podcast Episodes
                  </a>
                </div>
              </div>

              <PodcastEpisode {podcast_episode} />
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</Layout>
